module.exports = {
  purge: {
    enabled: process.env.NODE_ENV === "production",
    content: ["./src/**/*.vue"],
  },
  theme: {
    screens: {
      sm: "640px",
      // => @media (min-width: 640px) { ... }

      md: "768px",
      // => @media (min-width: 768px) { ... }

      lg: "1024px",
      // => @media (min-width: 1024px) { ... }

      xl: "1280px",
      // => @media (min-width: 1280px) { ... }
      "2xl": "2000px",
    },
    extend: {
      height: {
        nav1080: "260px",
        nav4K: "260px",

        /* Preview Component height */
        "sm-small": "280px",
        "sm-big": "280px",
        "md-small": "150px",
        "md-big": "210px",
        "lg-small": "210px",
        "lg-big": "280px",
        "xl-small": "280px",
        "xl-big": "350px",
        ds: "280px",
        db: "350px",
        "4Kds": "480px",
        "4Kdb": "550px",
      },
      inset: {
        "1080": "32%",
        "4K": "20%",
        "video-156": "-156px",
        "video-4/12": "16.66%"
      },
      margin: {
        lg: "260px",
        "4K": "260px",
      },
    },
  },
  variants: {},
  plugins: [],
};
